export default "__VITE_ASSET__6bba93f2__"